import React from 'react';

import { DatePickerWebV3 } from '@components/DatePicker/DatePickerWebV3';
import { Box, ShadowBox } from '@components/Restyle';

export type PopupTaskFilterDuedateProps = {
  onSelectDate?: (dr: Date | undefined) => void;
  selectedDate?: Date | undefined;
  onClose?: () => void;
};

export const PopupTaskFilterDuedateV3: React.FC<
  PopupTaskFilterDuedateProps
> = ({ onSelectDate, selectedDate }) => {
  return (
    <ShadowBox
      flex={1}
      width={360}
      alignItems='center'
      justifyContent='center'
      borderRadius='xs'
      variant='base'
      backgroundColor='white'>
      <Box
        flex={1}
        style={{ width: 360, height: 380 }}
        justifyContent='flex-end'>
        <DatePickerWebV3
          minDate={undefined}
          maxDate={undefined}
          selectedDate={selectedDate}
          onSelectDate={(date: Date | undefined) => {
            onSelectDate?.(date);
          }}
        />
      </Box>
    </ShadowBox>
  );
};
